import { BaseService } from '../../../infra/base.service'
import type { Profile } from './profile'
import type { SitesProfilesRepository } from './profiles.repository'

export class SitesProfilesService extends BaseService<Profile> {
    constructor(private rep: SitesProfilesRepository) {
        super(rep)
    }

    async updateTimezone(timezone: number) {
        return await this.rep.updateTimezone(timezone)
    }
}
